import { PropsWithChildren } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

type ModelPopupControlProps = PropsWithChildren<{
    show: boolean;
    title: string;
    description: string;
    isHtml?: boolean;
    onClose?: () => void;
  }>;
  

  export const ModelPopup = (props: ModelPopupControlProps) => {
  return (
    <Modal
    
    onHide={props.onClose}
    animation={false}
    scrollable
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title ?? ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.isHtml ? <div dangerouslySetInnerHTML={{__html: props.description}}></div> : <p>
          {props.description ?? ''}
        </p>}
        
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}